import { initMixin } from './init';
import { startMixin } from './start';

/**
 * Creates a constructor for the WebViewer API and adds instance methods to it.
 * @param options
 * @constructor
 */
export default function WebViewer (options) {
  if (!(this instanceof WebViewer)) {
    throw new Error('WebViewer is intended to be used as a constructor.');
  }

  this._init(options);
}

initMixin(WebViewer);
startMixin(WebViewer);



// WEBPACK FOOTER //
// ./src/viewer/core/instance/index.js